import React, { useEffect } from 'react';
import { SpinnerIcon } from 'components/common/Utils';
import Icon from '@/components/ui/Icon';
import useSpeechstream from './useSpeechStream';
import styles from './TextToSpeechButton.module.scss';

interface TTSButtonProps {
  idToRead: string;
  isInSlide?: boolean;
  locale: Locale;
  speed?: string;
}

const SpeakElementButton = ({ idToRead, isInSlide, locale, speed }: TTSButtonProps) => {
  const { playing, toggleSpeech, loaded, setNoScroll } = useSpeechstream({ idToRead, locale, speed });
  const label = playing ? 'Pause' : 'Play';
  const iconClass = playing ? 'fa-pause' : 'fa-volume-up';
  const icon = playing ? (<Icon icon="Pause" size={14} />) : (<Icon icon="Audio" size={14} />);

  useEffect(() => {
    setNoScroll(true);
  }, [loaded]);

  if (isInSlide) {
    return (
      <div className={styles.seButtonWrapper}>
        <button
          aria-label={label}
          className="btn btn--outline-purple btn--sm speak-question-button"
          type="button"
          onClick={toggleSpeech}
        >
          {loaded ? <i aria-hidden="true" className={`fa ${iconClass}`} /> : <SpinnerIcon />}
        </button>
      </div>
    );
  }

  return (
    <button
      aria-label={label}
      className="btn btn--outline-purple btn--sm speak-question-button tw-w-8 tw-h-6 tw-z-10"
      type="button"
      onClick={toggleSpeech}
    >
      {loaded
        ? (
          <div
            className="tw-flex tw-justify-center tw-items-center"
          >
            {icon}
          </div>
        )
        : <SpinnerIcon />}
    </button>
  );
};

export default SpeakElementButton;
